<template>
    <div class="content">
        <div class="card-wrap">
            <div class="card-title flc">
                <div class="color-block"></div>
                <div class="card-title-text">需求详情</div>
            </div>
            <div class="little-title">房屋类型</div>
           
            <div class="card-select" @click="chooseRoomType">
                {{Rooms_type}}
            </div>
            <div class="little-title">户型概况</div>
            <div class="hx-list">
                <!-- 这个是通过使用一个input使用绝对定位覆盖在div上面，从而实现点击盒子编辑，在item.status为false，就显示的是名字，如果有值，就显示单位 -->
                <div class="hx-item" :style="{color:item.status?'#444444':'#A2A2A2'}" v-for="(item, index) in hxList" :key="index">
                    <input type="number" :class="index == 6?'FloorHeight':''" @focus="item.status = true" @blur="blur(index)" @input="numlength(index,item.maxlength)" v-model="hxList[index].num">
                    <!-- 层高时候单位不同 -->
                    <span v-if="item.Company == '米'">{{item.status?'层高':''}}</span>
                    <span v-if="index == 4">
                     {{item.num.slice(0,7)}}{{item.status?item.Company:item.name}}
                    </span>
                    <span v-else>
                     {{item.num.slice(0,5)}}{{item.status?item.Company:item.name}}
                    </span>
                </div>
            </div>
            <div class="little-title">保温情况</div>
            <div class="bw-list flc">
                <div class="bw-item" :class="warm_keep_status.length != 4?'activeBox':''"  @click='warm_keep'>{{warm_keep_status}}</div>
                <div class="bw-item" :class="warm_length_status.length != 3?'activeBox':''"  @click="war_length">{{warm_length_status}}</div>
            </div>
            <div class="little-title">装修情况</div>
            <div class="card-select" @click="chooseDecorations">
                {{Decoration}}
            </div>
            <div class="little-title">常住人口</div>
            <div class="bw-item"  :style="{color:peopleNum.status?'#444444':'#A2A2A2'}" style="width: 100%">
                <input class="peopleNum" type="number" @focus="peopleNum.status = true" @blur="blur2" @input="numlength2(peopleNum.maxlength)" v-model="peopleNum.num">
                {{peopleNum.num}}{{peopleNum.status?peopleNum.Company:peopleNum.name}}</div>
            <div class="little-title">人员标签</div>
            <div class="bw-list person-list flc" v-if="ReportTagsData.length > 0">
                <div class="bw-item" :class="currentLabel.findIndex(i => i==item.id) != -1?'activeBox':''" @click="label(item.id)" v-for="(item,index) in ReportTagsData[2].items" :key="index">{{item.name}}</div>
            </div>
            <div class="little-title">作息需求</div>
            <div class="bw-list person-list flc" v-if="ReportTagsData.length > 0 ">
                <div class="bw-item" :class="currentWork== item.id?'activeBox':''" @click="workTime(item.id)" v-for="(item,index) in ReportTagsData[3].items" :key="index">{{item.name}}</div>
            </div>
        </div>
        <div class="card-wrap card-wrap-bottom">
            <div class="card-title flc">
                <div class="color-block"></div>
                <div class="card-title-text">体验记录</div>
            </div>
            <div class="step">
                <div class="step-item step-2"   v-for="(item,index) in logs" :key="index">
                    <!-- item.log_state代表当前的状态 ，state>log_state说明这个是已经过去了的状态，只有在state==log_state的时候，说明这个是正处于的状态-->
                    
                    <div v-if="item.log_state == 1 && item.state > item.log_state" >
                        <img class="step-index" src="@/assets/images/user/talk/step-icon1.png" alt="">
                        <div class="title color-grey">
                            <span>
                            <span class="color-grey">已预约<span v-if="item.log_cancel == 1">（已取消）</span></span>
                            </span><span class="time">{{item.log_created_at}}</span></div>
                        <div class="infos color-grey" >
                            <div>体验地点:{{item.experience_address}}</div>
                            <div class="record-addr">
                                <span class="record-time">预约时间：</span>
                                <span>
                                    <span v-for="(ele,i) in item.sub" :key="i">{{ele.mark_start.split('-').join('.').substring(0,16)}}~{{ele.mark_end.substring(11,16)}}
                                </span>
                                </span>
                            </div>
                            <div v-if="item.prospect_name.length > 0">支持人员:{{item.prospect_name.join(',')}}</div>
                            <div class="record-info">
                                <div class="remark-title">备注：</div>
                                <div class="remark-info">
                                    <span class="remark-info-item">
                                        {{remarks(item.sub)}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div v-if="item.remarks" class="color-grey remarks">{{item.remarks}}</div>
                        <img v-if="index !=  ReportListData.length - 1" class="Dotted-line" src="@/assets/images/user/talk/border-bottom.png" alt="">
                    </div>

                    <div v-if="item.log_state == 1 && item.state == item.log_state" >
                        <img class="step-index" src="@/assets/images/user/talk/step-icon11.png" alt="">
                        <div  class=" title ">
                            <span>
                            <span class="color-green">已预约</span>
                            </span><span class="time color-black">{{item.log_created_at}}</span></div>
                        <div class="infos color-black">
                            <div>体验地点:{{item.experience_address}}</div>
                            <div class="record-addr">
                                <span class="record-time">预约时间：</span>
                                <span>
                                    <span v-for="(ele,i) in item.sub" :key="i">{{ele.mark_start.split('-').join('.').substring(0,16)}}~{{ele.mark_end.substring(11,16)}}
                                </span>
                                </span>
                            </div>
                            <!-- <div>预约时间:{{ item.mark_date.split('-').join('.')+' '+ item.mark_start.substring(11,16)+'~'+item.mark_end.substring(11,16)}}</div> -->
                            <div v-if="item.prospect_name.length > 0">支持人员:{{item.prospect_name.join(',')}}</div>
                            <div class="record-info">
                                <div class="remark-title">备注：</div>
                                <div class="remark-info">
                                    <span class="remark-info-item">
                                        {{remarks(item.sub)}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div  class="remarks color-black">{{item.remarks}}</div>
                        <img v-if="index !=  ReportListData.length - 1" class="Dotted-line" src="@/assets/images/user/talk/border-bottom.png" alt="">
                    </div>

                    <div v-if="item.log_state == 2&& item.state > item.log_state &&item.state !=3&&item.state !=4">
                        <img class="step-index"  src="@/assets/images/user/talk/step-icon1.png" alt="">
                        <div class="title color-grey">
                            <span>
                            <span class="color-grey">已邀请<span v-if="item.log_cancel == 1">（已取消）</span></span>
                            </span>
                            <span class="time">{{item.log_created_at}}</span></div>
                        <div class="infos color-grey">
                            <div>体验邀约:已邀请</div>
                            <div class="record-addr">
                                <span class="record-time">预约时间：</span>
                                <span>
                                    <span v-for="(ele,i) in item.sub" :key="i">{{ele.mark_start.split('-').join('.').substring(0,16)}}~{{ele.mark_end.substring(11,16)}}
                                </span>
                                </span>
                            </div>

                            <div v-if="item.experience_address">体验地点:{{item.experience_address}}</div>
                            <div v-if="item.prospect_name.length > 0">支持人员:{{item.prospect_name.join(',')}}</div>
                            <div class="record-info">
                                <div class="remark-title">备注：</div>
                                <div class="remark-info">
                                    <span class="remark-info-item">
                                        {{remarks(item.sub)}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div v-if="item.remarks" class="color-grey remarks">{{item.remarks}}</div>
                        <img class="Dotted-line" src="@/assets/images/user/talk/border-bottom.png" alt="">
                    </div>


                    <div v-if="item.log_state == 2 && item.state == item.log_state" >
                        <img class="step-index" src="@/assets/images/user/talk/step-icon22.png" alt="">
                        <div  class=" title color-black">
                            <span>
                            <span class="color-green">已邀请</span>
                            </span><span class="time">{{item.log_created_at}}</span></div>
                        <div class="infos color-black">
                            <div>体验状态:已邀请</div>
                            <div>体验地点:{{item.experience_address}}</div>
                            <div class="record-addr">
                                <span class="record-time">预约时间：</span>
                                <span>
                                    <span v-for="(ele,i) in item.sub" :key="i">{{ele.mark_start.split('-').join('.').substring(0,16)}}~{{ele.mark_end.substring(11,16)}}
                                </span>
                                </span>
                            </div>

                            <div v-if="item.prospect_name.length > 0">支持人员:{{item.prospect_name.join(',')}}</div>
                            <div class="record-info">
                                <div class="remark-title">备注：</div>
                                <div class="remark-info">
                                    <span class="remark-info-item">
                                        {{remarks(item.sub)}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div  class="remarks color-black">{{item.remarks}}</div>
                        <img v-if="index !=  ReportListData.length - 1" class="Dotted-line" src="@/assets/images/user/talk/border-bottom.png" alt="">
                    </div>


                    <div v-if="item.log_state == 3&&item.state > item.log_state">
                        <img class="step-index" src="@/assets/images/user/talk/step-icon1.png" alt="">
                        <div class="title color-grey">
                            <span>
                            <span>已邀请<span v-if="item.log_cancel == 1">（已取消）</span></span></span>
                            <span class="time">{{item.log_created_at}}</span></div>
                        <div class="infos color-grey">
                            <div>体验邀约:已邀请——已接受</div>
                            <div class="record-addr">
                                <span class="record-time">预约时间：</span>
                                <span>
                                    <span v-for="(ele,i) in item.sub" :key="i">{{ele.mark_start.split('-').join('.').substring(0,16)}}~{{ele.mark_end.substring(11,16)}}
                                </span>
                                </span>
                            </div>

                            
                            <div v-if="item.experience_address">体验地点:{{item.experience_address}}</div>
                            <div v-if="item.prospect_name.length > 0">支持人员:{{item.prospect_name.join(',')}}</div>
                            <div class="record-info">
                                <div class="remark-title">备注：</div>
                                <div class="remark-info">
                                    <span class="remark-info-item">
                                        {{remarks(item.sub)}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div v-if="item.remarks" class="color-grey remarks">{{item.remarks}}</div>
                        <img  class="Dotted-line" src="@/assets/images/user/talk/border-bottom.png" alt="">
                    </div>

                    <div v-if="item.log_state == 3&&item.state == item.log_state">
                        <img class="step-index" src="@/assets/images/user/talk/step-icon22.png" alt="">
                        <div class="title">
                            <span>
                            <span class="color-green">已邀请<span v-if="item.log_cancel == 1">（已取消）</span></span></span>
                            <span class="time">{{item.log_created_at}}</span>
                        </div>
                        <div class="infos color-black">
                            <div>体验邀约:已邀请——已接受</div>
                            <div class="record-addr">
                                <span class="record-time">预约时间：</span>
                                <span>
                                    <span v-for="(ele,i) in item.sub" :key="i">{{ele.mark_start.split('-').join('.').substring(0,16)}}~{{ele.mark_end.substring(11,16)}}
                                </span>
                                </span>
                            </div>

                            <div v-if="item.experience_address">体验地点:{{item.experience_address}}</div>
                            <div v-if="item.prospect_name.length > 0">支持人员:{{item.prospect_name.join(',')}}</div>
                            <div class="record-info">
                                <div class="remark-title">备注：</div>
                                <div class="remark-info">
                                    <span class="remark-info-item">
                                        {{remarks(item.sub)}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div v-if="item.remarks" class="color-black remarks">{{item.remarks}}</div>
                        <img  class="Dotted-line" src="@/assets/images/user/talk/border-bottom.png" alt="">
                    </div>

                    <div v-if="item.log_state == 4">
                        <img class="step-index" src="@/assets/images/user/talk/step-icon33.png" alt="">
                        <div class="title" >
                            <span>
                            <span class="color-green" :class="{'color-grey':item.log_cancel == 1}">已体验<span v-if="item.log_cancel == 1">（已取消）</span></span></span>
                            <span class="time">{{item.log_created_at}}</span></div>
                        <div class="infos">
                            <div>体验状态:已体验</div>
                            <div class="record-addr">
                                <span class="record-time">预约时间：</span>
                                <span>
                                    <span v-for="(ele,i) in item.sub" :key="i">{{ele.mark_start.split('-').join('.').substring(0,16)}}~{{ele.mark_end.substring(11,16)}}
                                </span>
                                </span>
                            </div>
                            <div>体验地点:{{item.experience_address}}</div>
                        </div>
                        <img  class="Dotted-line" src="@/assets/images/user/talk/border-bottom.png" alt="">
                    </div>
                    <!-- 没有已邀请的时候显示 -->
                    <!-- <div class="color-grey" v-if="ReportUserInfoData.count[2].num == 0  ">  -->
                    <div class="color-grey" v-if="ReportUserInfoData.count[2].num == 0 &&ReportUserInfoData.count[1].num == 0 && index == logs.length -1 "> 
                        <img class="step-index" src="@/assets/images/user/talk/step-icon2.png" alt="">
                        <div class="title" >
                            <span>
                            <span >待邀请</span>
                            <span></span></span>
                        </div>
                        <div class="infos">
                                <!-- <div>体验邀约:已邀请———已接受</div>
                                <div>支持人员:</div>
                                <div>备注：</div> -->
                                <br>
                            </div>
                        <img  class="Dotted-line" src="@/assets/images/user/talk/border-bottom.png" alt="">
                    </div>
                    <!-- 没有已体验的时候展示 -->
                    <!-- <div class="color-grey" v-if="ReportUserInfoData.count[3].num == 0 ">  -->
                    <div class="color-grey" v-if="ReportUserInfoData.count[3].num == 0 && index ==logs.length -1 "> 
                        <img class="step-index" src="@/assets/images/user/talk/step-icon3.png" alt="">
                        <div class="title" >
                            <span>
                            <span >待体验</span>
                            <span></span></span>
                        </div>
                        <div class="infos">
                                <!-- <div>体验状态:已体验/未体验</div>
                                <div>打卡记录</div> -->
                                <br>
                            </div>
                        <img  class="Dotted-line" src="@/assets/images/user/talk/border-bottom.png" alt="">
                    </div>
                </div>
                <!-- 这个是如果体验记录一条都没的时候显示 ，如果有1条或者2条的时候就会加载上面-->
                <div v-if="logs">
                    <div class="step-item step-2" v-if="logs.length == 0">
                        <div class="color-grey"> 
                            <img class="step-index" src="@/assets/images/user/talk/step-icon111.png" alt="">
                            <div class="title" >
                                <span>
                                <span >待预约</span>
                                <span></span></span>
                            </div>
                            <div class="infos">
                                    <!-- <div>支持人员:</div>
                                    <div>备注：</div> -->
                                    <div>暂未预约用户体验</div>
                                </div>
                            <img  class="Dotted-line" src="@/assets/images/user/talk/border-bottom.png" alt="">
                        </div>
                        <div class="color-grey"> 
                            <img class="step-index" src="@/assets/images/user/talk/step-icon2.png" alt="">
                            <div class="title" >
                                <span>
                                <span >待邀请</span>
                                <span></span></span>
                            </div>
                            <div class="infos">
                                    <!-- <div>体验邀约:已邀请———已接受</div>
                                    <div>支持人员:</div>
                                    <div>备注：:</div> -->
                                    <br>
                                </div>
                            <img  class="Dotted-line" src="@/assets/images/user/talk/border-bottom.png" alt="">
                        </div>
                        <div class="color-grey"> 
                            <img class="step-index" src="@/assets/images/user/talk/step-icon3.png" alt="">
                            <div class="title" >
                                <span>
                                <span >待体验</span>
                                <span></span></span>
                            </div>
                            <div class="infos">
                                    <!-- <div>体验状态:已体验/未体验</div>
                                    <div>打卡记录</div> -->
                                    <br>
                                </div>
                            <img  class="Dotted-line" src="@/assets/images/user/talk/border-bottom.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn" @click="skip">预约</div>
        </div>  
        <van-popup v-model="BtypeShow" round position="bottom">
            <van-picker show-toolbar @confirm='confirmType' @cancel='cancelType' title="请选择" :columns="columns" value-key="name"/>
        </van-popup>
    </div>
</template>

<script>
import { fetchVerifyAuthForB} from '@/libsV2/havc.js'

    export default {
        name: "talkRecord",
        data() {
            return {
                accountId : '',//潜客id
                columns:[],//弹窗需要的数组
                choosetype:'',//当前处于的选择器
                BtypeShow:false,//控制点击选择房屋
                Rooms_type:'选择房屋类型',//选中的房屋类型
                Decoration:'选择装修情况',//选中的装修情况
                hxList: [
                    {num:'',name:'室',status:false,Company:'室',maxlength:4},
                    {num:'',name:'厅',status:false,Company:'厅',maxlength:4},
                    {num:'',name:'卫',status:false,Company:'卫',maxlength:4},
                    {num:'',name:'厨',status:false,Company:'厨',maxlength:4},
                    {num:'',name:'建筑面积',status:false,Company:'㎡',maxlength:7},
                    {num:'',name:'楼层数',status:false,Company:'层',maxlength:4},
                    {num:'',name:'层高',status:false ,Company:'米',maxlength:5}
                ],//这个的初始化在created中
                peopleNum:{
                    num:'',name:'人员数量',status:false,Company:'人',maxlength:2
                } ,//这个初始化也是在created中
                warm_keep_status:'外墙保温',
                warm_length_status:'隔热窗',
                step:[],
                currentLabel:[],//人员标签
                currentWork:'',//作息需求id
                currentRoom:'',//房屋类型id
                currentDecorat:'',//装修状态
            }
        },
        methods: {
            // 标签点击
            label (id) {
                const index = this.currentLabel.findIndex( i => i == id)
                // 判断标签数组中是否已经存在当前标签，如果存在就删除，不存在就添加
                if (index != -1) {
                    this.currentLabel.splice(index,1)
                } else {
                    this.currentLabel.push(id)
                }
            },
            // 作息点击
            workTime (id) {
                // 由于作息只能单选，所以直接判断作息的id是不是当前的id，如果是就让这个id清空，不是就替换掉之前的id
               if (id == this.currentWork) {
                   this.currentWork = ''
               } else {
                   this.currentWork = id
               }
            },
            // 外墙保温
            warm_keep () {
                this.columns = [{name:'有'},{name:'无'}]
                this.choosetype = 'warm_keep'
                this.BtypeShow = true
            },
            // 隔热窗
            war_length () {
                this.columns = [{name:'单'},{name:'双'}]
                this.choosetype = 'warm_length'
                this.BtypeShow = true
            },
            blur2 () {
                // input失去焦点的时候判断，这个户型对象有没有数值，如果有，就让他显示数值 + 单位，如果没有，就显示 名字
                if (this.peopleNum.num) {
                    this.peopleNum.status = true
                } else {
                    this.peopleNum.status = false
                }
            },
            numlength2 (maxlength) {
                // 限制用户输入的长度，如果输入的过长，就截取限制的长度作为数值
                if(this.peopleNum.num.length>maxlength) this.peopleNum.num=this.peopleNum.num.slice(0,maxlength)
            },
            blur (index) {
                // input失去焦点的时候判断，这个户型对象有没有数值，如果有，就让他显示数值 + 单位，如果没有，就显示 名字
                if (this.hxList[index].num) {
                    this.hxList[index].status = true;
                } else {
                    this.hxList[index].status = false;
                }
            },
            // 限制输入数量长度
            numlength (index,maxlength) {
                if(this.hxList[index].num.length>maxlength) this.hxList[index].num=this.hxList[index].num.slice(0,maxlength)
                if (index == 6 && this.hxList[index].num >= 99.99) {
                    this.hxList[index].num = '99.99'
                } else if (index == 4 && this.hxList[index].num >= 9999.99) {
                    this.hxList[index].num = '9999.99'
                } else if (index !=6 && index != 4){
                    this.hxList[index].num = Math.round(this.hxList[index].num) + ''
                }
            },  
            /**
            * 跳页,点击预约
            */
            skip() {
                // 因为提交需求他必须携带4个参数，房屋类型，装修情况，作息需求，人员标签，
                // 所以只有当这4个信息都填了之后，提交需求才会发送请求
                // 不然就是直接跳转
                if (this.currentRoom!= '' && this.currentDecorat!= '' && this.currentLabel.length != 0 && this.currentWork != '') {
                    const config_ids = this.currentLabel.join(',')+','+this.currentWork+','+this.currentRoom+','+this.currentDecorat
                    const num_bed = this.hxList[0].num
                    const num_hall = this.hxList[1].num
                    const num_toliet = this.hxList[2].num
                    const num_kitchen = this.hxList[3].num
                    const area = this.hxList[4].num
                    const rooms = this.hxList[5].num
                    const floor = this.hxList[6].num
                    const warm_keep = this.warm_keep_status == '有外墙保温'?1:0
                    const warm_length = this.warm_length_status == '单层隔热窗'?1:2
                    const people = this.peopleNum.num
                    const options = {
                        num_bed,num_hall,num_toliet,num_kitchen,area,rooms,floor,warm_keep,people,warm_length
                    }
                    this.$store.dispatch({type: 'userTalkAppoint/getReportConfigData',report_id:this.ReportUserInfoData.id,config_ids,...options});
                } 
                this.$router.push({ path: '/hvac/talk/appoint',query:{id:this.ReportUserInfoData.user_id_ao} })
            },
            // 点击选择房屋类型
            chooseRoomType () {
                this.columns = this.ReportTagsData[0].items
                this.BtypeShow = true
                this.choosetype = 'room'
            },
            // 关闭弹窗
            closePopup () {
                this.BtypeShow = false
            },
            // 选中触发的函数
            confirmType (selected) {
                console.log(selected,'select');
                // 判断点击的类型，有多个点击都是弹出选择框，
                // room         代表点击了房屋类型
                // Decoration   代表点击了装修情况
                // warm_keep    代表点击了外墙保温
                // warm_length  代表点击了隔热窗
                if (this.choosetype == 'room') {
                    this.Rooms_type = selected.name
                    this.currentRoom = selected.id
                } else if (this.choosetype == 'Decoration') {
                    this.Decoration = selected.name
                    this.currentDecorat = selected.id
                } else if (this.choosetype == 'warm_keep') {
                    this.warm_keep_status = selected.name + '外墙保温'
                } else if (this.choosetype == 'warm_length') {
                    this.warm_length_status = selected.name + '层隔热窗'
                }
                this.BtypeShow = false
            },
            // 取消选择type触发的函数
            cancelType () {
                this.BtypeShow = false
            },
            // 点击选择装饰情况触发的函数
            chooseDecorations () {
                this.BtypeShow = true
                this.choosetype = 'Decoration'
                this.columns = this.ReportTagsData[1].items
            },
            // 获取潜客id
            getAccountId () {
                this.accountId = this.$route.query.accountid;
            },
            // 每个预约记录的备注
            remarks (list) {
                let remarks = []
                if (list.length == 0 ) {
                    return []
                }
                // 备注数组去重，同时不显示 备注为空
                list.forEach( (item,index) => {
                    if ( item.mark != '' ) {
                        const i = list.findIndex( item2 => item2.mark == item.mark )
                        if ( i == index) {
                            remarks.push(item.mark)
                        }
                    }
                })
                return remarks.join(' /')
            },
        },
        computed :{
            
            // 预约回顾的数据列表
            logs () {
                // 自定义一个排序方法，使用sort对数据进行排序
                function compare(property){
                    return function(a,b){
                        var value1 = a[property];
                        var value2 = b[property];
                        return value1-  value2 
                    }
                }
                // 防止数据还没有获取到出现的报错
                if (this.ReportUserInfoData.logs) {
                    let list = this.ReportUserInfoData.logs
                    // console.log(list,'list');
                    list= list.sort(compare('log_state'))
                    return list
                }
            },
            // 获取当前时间
            newDate () {
                let newDate = new Date();
                const year = newDate.getFullYear();
                let month = newDate.getMonth() + 1;
                let date = newDate.getDate();
                let minute = newDate.getMinutes();
                let second = newDate.getSeconds()
                let hour = newDate.getHours();
                month = (month < 10) ? '0' + month : month
                date = (date < 10) ? '0' + date : date
                hour = (hour < 10) ? '0' + hour : hour
                minute = (minute < 10) ? '0' + minute : minute
                second = (second < 10) ? '0' + second : second
                return   year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
            },
            // 报告信息，标签组
            ReportTagsData() {
                return this.$store.state.userTalkAppoint.ReportTagsData
            },
            //报告信息，用户信息
            ReportUserInfoData() {
                return this.$store.state.userTalkAppoint.ReportUserInfoData
            },
            ReportListData () {
                return this.$store.state.userTalkAppoint.ReportListData
            }
        },
        created () {
            // $init(() => {
                fetchVerifyAuthForB (() => {
                    if (!this.$route.query.accountid) {
                        this.$toast({message: "参数缺失"})
                    } else {
                        this.getAccountId()
                        this.$store.dispatch({type: 'userTalkAppoint/getReportInfoData',accountid:this.$route.query.accountid}).then(() => {
                            console.log('zhlui dsafjksdafjksdjkafj kljkl');
                            // console.log(this.ReportUserInfoData.id,'baogaoid');
                            if(this.ReportUserInfoData.is_demand == 0) {
                                return
                            }
                            // 循环遍历config_ids，里面的id就是tags里的
                            // 确保config_ids不是一个空数组
                            if ( this.ReportUserInfoData.config_ids.length > 0 ) {
                                let peopleLabelList = []
                                this.ReportUserInfoData.config_ids.forEach(item =>{
                                    // item就是一个一个的id值
                                    // 设置房屋类型
                                    const roomTypeObj = this.ReportTagsData[0].items.find(i => i.id == item)
                                    if (roomTypeObj) {
                                        this.currentRoom = roomTypeObj.id
                                        this.Rooms_type = roomTypeObj.name
                                    }
                                    // 设置装修情况
                                    const DecorationObj = this.ReportTagsData[1].items.find(i => i.id == item)
                                    if (DecorationObj) {
                                        this.currentDecorat = DecorationObj.id
                                        this.Decoration = DecorationObj.name
                                    }
                                    // 设置作息需求
                                    const currentWorkObj = this.ReportTagsData[3].items.find(i => i.id == item)
                                    if (currentWorkObj) {
                                        this.currentWork = currentWorkObj.id
                                    }
                                    // 设置人员标签
                                    const PeopleLabelObj = this.ReportTagsData[2].items.find(i => i.id == item)
                                    if (PeopleLabelObj) {
                                        peopleLabelList.push(PeopleLabelObj.id)
                                    }
                                })
                                this.currentLabel = peopleLabelList
                            }
                            // 设置户型内容
                            this.hxList = [
                                {num:this.ReportUserInfoData.num_bed,name:'室',status:this.ReportUserInfoData?.num_bed,Company:'室',maxlength:4},
                                {num:this.ReportUserInfoData.num_hall,name:'厅',status:this.ReportUserInfoData?.num_hall,Company:'厅',maxlength:4},
                                {num:this.ReportUserInfoData.num_toilet,name:'卫',status:this.ReportUserInfoData?.num_toilet,Company:'卫',maxlength:4},
                                {num:this.ReportUserInfoData.num_kitchen,name:'厨',status:this.ReportUserInfoData?.num_kitchen,Company:'厨',maxlength:4},
                                {num:this.ReportUserInfoData.area,name:'建筑面积',status:this.ReportUserInfoData?.area,Company:'㎡',maxlength:7},
                                {num:this.ReportUserInfoData.rooms,name:'楼层数',status:this.ReportUserInfoData?.rooms,Company:'层',maxlength:4},
                                {num:this.ReportUserInfoData.floor,name:'层高',status:this.ReportUserInfoData?.floor ,Company:'米',maxlength:5}
                            ]
                            // 设置房屋是否保温00
                            if (this.ReportUserInfoData.warm_keep != '') {
                                this.warm_keep_status = this.ReportUserInfoData.warm_keep?'无外墙保温':'有外墙保温'
                            }
                            // 设置隔热窗层数
                            if (this.ReportUserInfoData.warm_length != '') {
                                this.warm_length_status = this.ReportUserInfoData.warm_length == 1?'单层隔热窗':'双层隔热窗'
                            }
                            // 设置人员数量
                            this.peopleNum = {
                                num:this.ReportUserInfoData.people,name:'人员数量',status:this.ReportUserInfoData.people,Company:'人',maxlength:2
                            } 
                        })
                    }
                })
            // })
        }
    }
</script>

<style lang="scss" scoped>
    .content {
        .card-wrap {
            width: 93.6%;
            margin: 0 auto;
            background: #FFFFFF;
            border-radius: 12px;
            padding: 32px 24px;

            /*卡片标题*/
            .card-title {
                .color-block {
                    width: 6px;
                    height: 32px;
                    background: #318544;
                    margin-right: 12px;
                }
                .card-title-text {
                    font-size: 32px;
                    font-weight: 600;
                    color: #318544;
                    line-height: 44px;
                }
            }
            // 体检记录
            .step {
                margin-top: 38px;
                padding: 0 8px 0 18px;
                .step-item {
                    position: relative;
                    padding:  0 0 0 38px;
                    
                    .step-index {
                        width: 36px;
                        height: 36px;
                        position:absolute;
                        left: -18px;
                        background-color: #FFFFFF;
                    }
                    .title {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        font-size: 28px;
                        font-weight: 400;
                        margin-bottom: 14px;
                        span:first-child {
                            font-size: 28px;
                            // color: #444444;
                        }
                        .time {
                            font-size: 24px;
                            // color: #A2A2A2;
                        }
                    }
                    .infos {
                        .record-info {
                            font-size: 24px;
                            font-weight: 400;
                            color: #858585;
                            line-height: 32px;
                            margin-top: 12px;
                            display: flex;
                            .record-time {
                                width: 130px;
                            }
                            .remark-title {
                                width: 80px;
                            }
                            .remark-info {
                                flex: 1;
                            }
                        }
                        div{    
                            margin-bottom: 8px;
                        }
                        .record-addr {
                            font-size: 24px;
                            font-weight: 400;
                            line-height: 32px;
                            margin-top: 12px;
                            display: flex;
                            .record-time {
                                width: 130px;
                            }
                            span:last-child{
                                text-align: left;
                                display: flex;
                                flex-direction: column;
                                span{
                                    height: 32px;
                                }
                            }
                        }
                    }
                        .color-green {
                            color: #318544;
                        }
                    .color-grey {
                        color: #A2A2A2;
                    }
                    .color-black {
                        color: #444444;
                    }
                    .remarks {
                        margin-bottom:8px;
                    }
                    &:last-child {
                        padding-bottom: 6px;
                    }
                } 

                .step-1 {
                    border-left: solid rgba(#318544,0.2) 2px;
                }
                .step-2 {
                    border-left: solid rgba(#A2A2A2,0.2) 2px;

                }
                .step-3 {
                    border-left: dotted rgba(black,0.2) 2px;
                }
            }

            .imgsList {
                display: flex;
                padding-left: 55px;
                div {
                    width: 110px;
                    height: 110px;
                    background: #F3F3F3;
                    margin-right: 14px;
                    &:last-child {
                        margin-right: 0;
                    }
                }
            }
            /*小标题*/
            .little-title {
                font-weight: 400;
                color: #444444;
                line-height: 40px;
                margin: 24px 0 16px;
                
            }

            /*下拉框样式*/
            .card-select {
                width: 100%;
                height: 60px;
                border-radius: 12px;
                border: 2px solid #DBDBDB;

                font-size: 24px;
                font-weight: 400;
                color: #444444;
                line-height: 60px;
                text-align: center;
            }

            /*户型列表*/
            .hx-list {
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-wrap: wrap;

                .hx-item {
                    width: 150px;
                    height: 80px;
                    background: #F7F7F7;
                    border-radius: 12px;
                    margin-bottom: 20px;
                    position:relative;
                    font-size: 28px;
                    font-weight: 400;
                    color: #A2A2A2;
                    line-height: 80px;
                    text-align: center;
                    input {
                        border-radius: 12px;
                        width: 150px;
                        position: absolute;
                        top: 0;
                        left:0;
                        bottom:0;
                        color: transparent;
                        background-color:transparent ;
                        caret-color: black;
                        text-align: center;
                        padding-right: 30px;
                    }
                    &:nth-child(5), &:nth-child(6), &:nth-child(7) {
                        width: 206px;
                        input {
                            width: 206px;
                        }
                    }
                    .FloorHeight{
                        padding-left: 65px;
                    }
                }
            }

            /*保温情况*/
            .bw-list {
                flex-wrap: wrap;
                .activeBox {
                    background: #EAF2EC;
                    color: #318544;
                }
            }
            .bw-item {
                margin-left: 10px;
                margin-top:10px;
                width: 316px;
                height: 80px;
                background: #F7F7F7;
                border-radius: 12px;
                font-size: 28px;
                font-weight: 400;
                color: #A2A2A2;
                line-height: 80px;
                position:relative;
                text-align: center;

                .peopleNum {
                    width: 100%;
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    color: transparent;
                    background-color: transparent;
                    caret-color: black;
                    text-align: center;
                    margin-left: -15px;
                }
                
            }
            .person-list {
                .bw-item {
                    width: 206px;
                }
                .activeBox {
                    background: #EAF2EC;
                    color: #318544;
                }
            }
        }

        .card-wrap-bottom {
            margin: 24px auto 70px;

            .btn {
                width: 352px;
                height: 72px;
                background: $userBgGradient;
                border-radius: 12px;

                font-size: 28px;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 72px;
                text-align: center;
                margin: 36px auto;
            }
        }
    }

    /*通用样式*/
    .flc {
        display: flex;
        align-items: center;
    }
</style>